// extracted by mini-css-extract-plugin
module.exports = {"popup":"bf_bh","isError":"bf_bj"};